@if (canReadActivity()) {
	@if (status() === 'loading') {
		<div class="activity-state" role="status" aria-live="polite">
			<mat-spinner diameter="32"></mat-spinner>
			<span>{{ 'institution.activity.loading' | transloco }}</span>
		</div>
	} @else if (status() === 'not-found') {
		<p class="activity-state" role="status">{{ 'institution.activity.not_available' | transloco }}</p>
	} @else if (status() === 'unauthorized') {
		<p class="activity-state" role="alert">{{ 'institution.activity.no_access' | transloco }}</p>
	} @else if (status() === 'error') {
		<div class="activity-state" role="alert">
			<span>{{ 'institution.activity.load_error' | transloco }}</span>
			<button mat-button type="button" (click)="retry()">{{ 'institution.activity.retry' | transloco }}</button>
		</div>
	} @else if (activity(); as data) {
		<section class="activity-section" aria-labelledby="active-clients-heading">
			<h2 id="active-clients-heading">{{ 'institution.activity.active_clients' | transloco }}</h2>
			<p class="active-client-count" aria-live="polite">{{ data.activeClientCount }}</p>
		</section>

		<section class="activity-section" aria-labelledby="active-professionals-heading">
			<h2 id="active-professionals-heading">{{ 'institution.activity.active_professionals' | transloco }}</h2>
			@if (data.activeProfessionals.length === 0) {
				<p>{{ 'institution.activity.no_active_professionals' | transloco }}</p>
			} @else {
				<table mat-table [dataSource]="data.activeProfessionals" class="activity-table">
					<ng-container matColumnDef="professional">
						<th mat-header-cell *matHeaderCellDef>{{ 'institution.activity.professional' | transloco }}</th>
						<td mat-cell *matCellDef="let professional">
							@if (canOpenUser(professional.userId)) {
								<a class="cell-link" [routerLink]="['/desk/user', professional.userId]">
									{{ professionalName(professional) }}
								</a>
							} @else {
								<span>{{ professionalName(professional) }}</span>
							}
						</td>
					</ng-container>
					<ng-container matColumnDef="ifd">
						<th mat-header-cell *matHeaderCellDef>IFD</th>
						<td mat-cell *matCellDef="let professional">
							@if (canOpenIfd(professional.integrationServiceOfficeId)) {
								<a
									class="cell-link"
									[routerLink]="['/desk/integration-service-office', professional.integrationServiceOfficeId]"
								>
									{{ integrationServiceOfficeName(professional) }}
								</a>
							} @else {
								<span>{{ integrationServiceOfficeName(professional) }}</span>
							}
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			}
		</section>
	}
}
